const normalizedProgram = (value = 'website') => String(value || 'website').trim().toLowerCase();
const programKey = (value = 'website') => {
  const normalized = normalizedProgram(value);
  if (normalized === 'rtrade' || normalized.includes('accutrade') || normalized.includes('trade')) return 'trade';
  if (normalized.includes('chat')) return 'chat';
  if (normalized.includes('website')) return 'website';
  return normalized;
};

const PROGRAM_CAPABILITIES = {
  website: {
    label: 'Website',
    dpeActions: true,
    historicalBackfill: true,
    historyDashboard: true,
  },
  chat: {
    label: 'Chat',
    dpeActions: true,
    historicalBackfill: true,
    historyDashboard: true,
  },
  trade: {
    label: 'Trade',
    dpeActions: true,
    historicalBackfill: true,
    historyDashboard: true,
  },
};

export const capabilitiesForProgram = (program = 'website') => {
  const normalized = programKey(program);
  return PROGRAM_CAPABILITIES[normalized] || {
    label: program || 'Unknown program',
    dpeActions: false,
    historicalBackfill: false,
    historyDashboard: false,
  };
};
